import * as Yup from 'yup'

export interface IPasswordSchema {
    new_password: string
    confirm_password: string
    transaction_password: string
    member_operation_type: string
}

const PasswordSchema = Yup.object({
    new_password: Yup.string().required('The Password field is required').min(8, 'The Password field must be at least 8 characters').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/, 'The Password field must contain at least 1 uppercase letter, 1 lowercase letter, 1 number'),
    confirm_password: Yup.string().required('The Confirm Password field is required').min(8, 'The Confirm Password field must be at least 8 characters').oneOf([Yup.ref('new_password'), ''], 'The Confirm Password confirmation does not match'),
    transaction_password: Yup.string().required('Transaction Code field is required')
})

export default PasswordSchema